import {createContext, useContext} from 'react';

export const AutoDeliverySectionIdContext = createContext(null);
export const useAutoDeliverySectionIdContext = () => useContext(AutoDeliverySectionIdContext);
